import React from "react";

export type Language = string;
export interface I18nSettings {
  language: Language;
  preferedLanguages: Language[];
  timezone: string;
}

interface I18n {
  translations: { [key: string]: string };
  refetchLanguages: () => void;
}
export const I18nContext = React.createContext<I18n>({
  translations: {},
  refetchLanguages: () => {},
});
